const endpoints = {
  get: {
    context: '/v1/users/context',
    hierarchySummary: '/v1/customers/hierarchy-summary',
  },
  put: {
    context: '/v1/users/context',
  },
};

export default endpoints;
